let updateCallback

const unregisterSW = async () => {
  try {
    if (navigator?.serviceWorker?.controller) {
      const registration = await navigator.serviceWorker.ready
      await registration.unregister()
    }
  } catch (error) {}
}

export const onUpdateSW = callback => {
  if (callback && typeof callback === 'function') {
    updateCallback = callback
  }
}

const addSWListeners = registration => {
  registration.addEventListener('updatefound', () => {
    const worker = registration.installing
    if (worker) {
      worker.addEventListener('statechange', () => {
        if (worker.state === 'installed' && navigator.serviceWorker.controller) {
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            updateCallback?.()
          })
        }
      })
    }
  })
}

const register = async swUrl => {
  try {
    const registration = await navigator?.serviceWorker?.register?.(swUrl)
    if (registration) {
      registration.update()
      addSWListeners(registration)
    }
  } catch (error) {
    unregisterSW()
  }
}

export const registerSW = async () => {
  if (process.env.NODE_ENV === 'production') {
    if (navigator?.serviceWorker) {
      try {
        const swUrl = '/sw.js'
        const response = await fetch(swUrl, {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache' }
        })
        if (response?.ok) {
          const contentType = response.headers.get('content-type')
          if (contentType?.includes('application/javascript')) {
            register(swUrl)
          }
        }
      } catch (error) {
        unregisterSW()
      }
    }
  }
}
